<template>
    <div class="infoScreen">
        <div class="leftContent" >
            <custom-header :full-img="true" :img-number="headerImg" ></custom-header>
        </div>
        <div class="rightContent">
            <div class="headBlock">
                <custom-header :full-img="true" :img-number="headerImg"></custom-header>
            </div>
            <div class="wrap infoScreen_content">
                <div>
                    <h1 v-if="titleH1" class="infoScreen_title" v-html="title"></h1>
                    <h2 v-else class="infoScreen_title text_truncate" v-html="title"></h2>
                </div>
                <div>
                    <p class="infoScreen_text" v-html="text"></p>
                    <slot></slot>
                </div>

                <div class="grow"></div>
                <slot name="middle"></slot>
                <div class="bottom">
                    <slot name="bottom">
                        <custom-button
                                v-if="!hideButton"
                                :button-text="buttonText"
                                success
                                :disabled="disabledButton"
                                :action="action"
                        />
                    </slot>
                </div>

                <div class="bottomLink">
                    <slot name="bottomLink"></slot>
                </div>
            </div>
        </div>

    </div>

</template>

<script>
    import CustomButton from "../../components/ui/custom-button";
    import CustomHeader from "../ui/custom-header";
    export default {
        name: "info-screen",
        components: {CustomHeader, CustomButton},
        props: {
            headerImg: {type: [String, Number], default: 1},
            title: String,
            text: String,
            buttonText: String,
            mainLogo: String,
            action: Function,
            titleH1: {type: Boolean, default: false},
            hideButton: {type: Boolean, default: false},
            disabledButton: {type: Boolean, default: false}
        },
    }
</script>

<style lang="scss" scoped>
    @import "../../scss/config.scss";
    .text_truncate{
        text-overflow: ellipsis;
        overflow: hidden;
    }
    .infoScreen {
        &_content {
            text-align: left;
            color: $text-color;
            display: flex;
            flex-direction: column;
            height: calc(100vh - 314px);
            justify-content: space-between;
        }
        &_title {
            margin-top: 0;
            color: $title-color;
        }
        &_text {
            margin-top: 16px;
        }
    }

    @media (min-width: 321px) and (max-width: 600px) {

    }
    @media (min-width: 601px) and (max-width: 750px) {

        .infoScreen_content {
            height: calc(100vh - 220px);
            max-height: 700px;
        }
    }
    @media (min-width: 751px) {
        .infoScreen_content {
            height: calc(100vh - 220px);
            max-height: 700px;
        }
    }



</style>